import Vue from "vue";
const state = () => ({
    // Loading
    loading: false,
});

const mutations = {
    // Loading
    END_BUSY_STATE(state, payload) {
        console.log("END_BUSY_STATE", payload)
        state.loading = false;
    },
    START_BUSY_STATE(state, payload) {
        if (this.state.Online.online) {
            console.log("START_BUSY_STATE", payload)
        state.loading = true;
        }
    },

    SET_BUSY_STATE(state, payload) {
        console.log("SET_BUSY_STATE", payload)
        state.loading = payload;
    },
};

const actions = {
    // Loading
    stopBusyState({ commit }) {
       // commit("END_BUSY_STATE");
    },
    startBusyState({ commit }) {
      //  commit("START_BUSY_STATE");
    },
};


const getters = {
    loading: (state) => {
        return state.loading;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};